
import Group from 'vux/src/components/group/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import ChinaAddressV4Data from 'vux/src/datas/china_address_v4.json'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import value2name from 'vux/src/filters/value2name.js'

export default {
components: {
Group,
XAddress,
XButton,
Cell
},
data() {
return {
defaultAddress:false,
showAddress:'',
id: this.$route.query.id,//地址id
patientid: this.$store.state.userInfo.id,//患者ID
receiver: this.$store.state.userInfo.patientname != null && this.$store.state.userInfo.patientname != '' ? this.$store.state.userInfo.patientname : '',//收件人姓名
telephone: this.$store.state.userInfo.telephone != null && this.$store.state.userInfo.telephone != '' ? this.$store.state.userInfo.telephone : '',//联系电话
country: '中国',//国家
province: '',//省/直辖市
city: '',//市
county: '',//区/县
address: '',//详细地址
title: '',
value: [],
addressData: ChinaAddressV4Data,
showAddress: false,
istrue: false,
switchValue1:false,
orederId: this.$route.query.orederId,
serviceid: this.$route.query.serviceid,
}
},

methods: {

deleteAddress(){
let _this=this;
this.$doRequest("/api/patientaddressinfo/delete", [this.$route.query.id.id]).then(res => {
if(res.result == 0){
_this.$router.back(-1);
}
})
},
doShowAddress () {
this.showAddress = true
setTimeout(() => {
this.showAddress = false
}, 2000)
},
onShadowChange (val,names) {
this.province = names[0];
this.city = names[1];
this.county = names[2];
},
verify(){
var regEn = /[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/im,
regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im;
if(regEn.test(this.receiver) || regCn.test(this.receiver)){
this.$toastMsg('请输入正确格式的收件人');
}
},
updateTop(){
window.scroll(0,0);
},
addAddress(){
if(this.$store.state.userInfo.telephone != ""&&this.telephone==""){
this.telephone = this.$store.state.userInfo.telephone;
}
if(this.receiver == ''){
this.$toastMsg('收件人不能为空');
return;
}
if(this.telephone == ''){
this.$toastMsg('联系方式不能为空');
return;
}
if(this.value == ''){
this.$toastMsg('收货地址不能为空');
return;
}
if(this.address == ''){
this.$toastMsg('详细地址不能为空');
return;
}






let params = {
patientid: this.$store.state.userInfo.id,//患者ID
receiver: this.receiver,//收件人姓名
telephone: this.telephone,//联系电话
country: this.country,//国家
province: this.province,//省/直辖市
city: this.city,//市
county: this.county,//区/县
address: this.address,//详细地址
isdefault:this.switchValue1?"1":"2"
}
let _this=this;
if(this.$route.query.id){
params.id= this.$route.query.id.id;
this.$doRequest("/api/patientaddressinfo/updatedizhi", params).then(res => {
_this.$router.push({path: '/addressedit',query: {orederId: this.orederId,serviceid:this.serviceid,}});
})
}else{
this.$doRequest("/api/patientaddressinfo/saveizhi", params).then(res => {
if(res.result == 1){
_this.$router.push({path: '/addressedit',query: {orederId: this.orederId,serviceid:this.serviceid}});
}
})
}

}
},

created: function(){
document.title =this.$route.query.id?'编辑收货地址': '新增收货地址';
this.$isLogin(window.location.search.substr(1));

},
mounted(){
if(this.$route.query.id){
console.log(this.$route.query.id);
this.receiver=this.$route.query.id.receiver;
this.telephone=this.$route.query.id.telephone;
this.address=this.$route.query.id.address;
this.switchValue1=this.$route.query.id.isdefault==1?true:false;
this.value=[this.$route.query.id.province,this.$route.query.id.city,this.$route.query.id.county];
this.serviceid=this.$route.query.serviceid;
}
}
}



// WEBPACK FOOTER //
// ./src/views/address/index.vue